import { IUser } from "models/user";

export const userParser = (userObject: any) => {
  const { first_name, last_name, mobile, email } = userObject;

  const parsedUser: IUser = {
    firstName: first_name,
    lastName: last_name,
    mobile: mobile,
    email: email,
  };
  return parsedUser;
};
